import React, {Component} from 'react'
import {connect} from 'react-redux'

import DocumentsTopBar from './DocumentsTopBar'
import {showWarningDialogIE} from "../data/DocumentListActions";
import axios from "axios";

class ExpiredTokenPage extends Component {
    constructor(props) {
        super(props)
        sessionStorage.clear();
    }

    componentDidMount() {
        history.pushState(null, null, location.href);
        history.back();
        history.forward();
        window.onpopstate = function () { history.go(1); };
    }

    componentWillUnmount() {
    };

    render = () => {
        return (
            <h3 style = {{textAlign: 'center', marginTop: '200px'}}>
                Your session has expired. Please re-open Calendar Builder from <a href="https://www.activityconnection.com">ActivityConnection.com</a>
            </h3>
        )
    }
}

// Which props do we want to inject, given the global state?
// Note: use https://github.com/faassen/reselect for better performance.
function mapStateToProps(state) {
    // stuff to chain down to dumb components
    // for now -- pass through the whole state
    return state
}

export default connect(mapStateToProps)(ExpiredTokenPage)



// WEBPACK FOOTER //
// ./src/components/ExpiredTokenPage.jsx